import AggregateStats from "./AggregateStats";

// The Dashboard component can be used to choose data cards and display them in
// custom layouts.  Unique cards contain unique data displays and visualizations.

//sideCardInventory displays cards in a sidebar on the Dashboard page
export const sideCardInventory = [];
//fullCardInventory displays cards in full width on the Dashboard page
export const fullCardInventory = [<AggregateStats/>];
